module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-header-mobile"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-s6"
  }, [_c('div', {
    attrs: {
      "id": "side-title"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('h1', [_vm._v("DAP"), _c('div', [_vm._v("studio")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col col-s6 btn-menu yo-align-right"
  }, [_c('a', {
    attrs: {
      "href": "#!"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$teras.mobMmenu = !_vm.$teras.mobMmenu
      }
    }
  }, [(_vm.$teras.mobMmenu) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")]) : _vm._e(), _vm._v(" "), (!_vm.$teras.mobMmenu) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("menu")]) : _vm._e()])])]), _vm._v(" "), (_vm.$teras.mobMmenu) ? _c('div', {
    staticClass: "row menu"
  }, [_c('div', {
    staticClass: "col col-s12"
  }, [_c('el-menu', {
    attrs: {
      "default-active": "1",
      "router": true,
      "unique-opened": true
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "contributi"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("ABOUT US")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "_page-team",
    attrs: {
      "index": "/inside/profilo/studio"
    }
  }, [_vm._v("profile")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "_page-team",
    attrs: {
      "index": "/inside/profilo/team"
    }
  }, [_vm._v("team")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "_page-team",
    attrs: {
      "index": "/inside/profilo/clienti"
    }
  }, [_vm._v("clients")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "_page-premi",
    attrs: {
      "index": "/inside/profilo/premi"
    }
  }, [_vm._v("awards")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "_page-mostre",
    attrs: {
      "index": "/inside/profilo/mostre"
    }
  }, [_vm._v("exhibitions")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "_page-pubblicazioni",
    attrs: {
      "index": "/inside/profilo/pubblicazioni"
    }
  }, [_vm._v("publications")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "_page-eventi",
    attrs: {
      "index": "/inside/profilo/eventi"
    }
  }, [_vm._v("events")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "comitati"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("PROJECTS")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "_page-selezione",
    attrs: {
      "index": "/progetti"
    }
  }, [_vm._v("selected")]), _vm._v(" "), _c('el-popover', {
    ref: "temiPop",
    attrs: {
      "placement": "left",
      "width": "140",
      "trigger": "hover"
    },
    model: {
      value: (_vm.temiPopV),
      callback: function($$v) {
        _vm.temiPopV = $$v
      },
      expression: "temiPopV"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/tema/1/interiors"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("interiors")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/2/graftings"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("graftings")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/3/reuse"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("reuse")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/4/relational spaces"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("relational spaces")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/5/texture"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("texture")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/6/sustainability"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("sustainability")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/7/transformation"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("transformation")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "popover",
      rawName: "v-popover:temiPop",
      arg: "temiPop"
    }],
    staticClass: "el-menu-item vmenupop"
  }, [_vm._v("topics")]), _vm._v(" "), _c('el-popover', {
    ref: "tipologiePop",
    attrs: {
      "placement": "left",
      "width": "140",
      "trigger": "hover",
      "offset": "0"
    },
    model: {
      value: (_vm.tipologiePopV),
      callback: function($$v) {
        _vm.tipologiePopV = $$v
      },
      expression: "tipologiePopV"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/tipologia/1/urban spaces and landscape"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("urban spaces and landscape")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tipologia/2/public buildings"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("public buildings")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tipologia/3/offices and commercial spaces"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("offices and commercial spaces")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tipologia/4/housing"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("housing")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tipologia/5/cultural projects"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("cultural projects")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tipologiePop",
      arg: "tipologiePop"
    }],
    staticClass: "el-menu-item vmenupop"
  }, [_vm._v("types")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/inside/contatti/contatti"
    }
  }, [_vm._v("CONTACTS")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-bottom yo-align-center"
  }, [_c('div', {
    staticClass: "nav-lang"
  }, [_c('a', {
    attrs: {
      "href": "/site"
    }
  }, [_vm._v("it")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("en")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/inside/coming/coming"
    }
  }, [_vm._v("fr")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "first _page-contatti",
    staticStyle: {
      "margin": "4px 0 8px 0",
      "display": "block"
    },
    attrs: {
      "to": "/inside/contatti/note_legali"
    }
  }, [_vm._v("legal notes")]), _vm._v(" "), _vm._m(0)], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-social"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/dap_studio"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/twitter.svg"),
      "alt": "Twitter icon"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/pages/DAPstudio-elena-sacco-paolo-danelli/160426864008613"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/facebook.svg"),
      "alt": "Facebook icon"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.instagram.com/dapstudio"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/instagram.svg"),
      "alt": "Instagram icon"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc4ec1bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header-mobile.vue
// module id = 366
// module chunks = 0